import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ENTRY_CLASS = 'klaus-entry';

/**
 * Deeplinks from Klaus point at one list entry (`?entry=<index>`, the
 * PersistentState index of a DSFA, contract partner, Datenschutzhinweis or
 * Einwilligung): its row is highlighted and scrolled into view once the list
 * has loaded. Plan: klaus-ki/docs/dieter-aufgaben-plan.md.
 */
export function useEntryHighlight() {
  const location = useLocation();
  const entry = new URLSearchParams(location.search).get('entry');

  useEffect(() => {
    if (!entry) return;
    // The list loads asynchronously: look for the row for a few seconds.
    let tries = 0;
    const timer = setInterval(() => {
      const row = document.querySelector(`.${ENTRY_CLASS}`);
      if (row || ++tries > 30) {
        clearInterval(timer);
        row?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 200);
    return () => clearInterval(timer);
  }, [entry]);

  /** Row props for MUIDataTable's setRowProps: the linked entry stands out. */
  const rowProps = (index: string | undefined, className?: string) =>
    entry && index === entry
      ? { className: [className, ENTRY_CLASS].filter(Boolean).join(' '), style: { outline: '2px solid #f5c400', outlineOffset: '-2px', background: '#fff8d6' } }
      : className
        ? { className }
        : {};

  return { entry, rowProps };
}
